import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import authService from './services/authService'
import { teamsAuthService } from './services/teamsAuth'

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import '@mdi/font/css/materialdesignicons.css'

const app = createApp(App)

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
})

// Initialize authentication services
const initializeAuth = async () => {
  try {
    // Check environment variables
    // console.log('Environment check:', {
    //   hasClientId: !!import.meta.env.VITE_AZURE_CLIENT_ID,
    //   hasTenantId: !!import.meta.env.VITE_AZURE_TENANT_ID,
    //   redirectUri: import.meta.env.VITE_REDIRECT_URI || window.location.origin,
    //   currentOrigin: window.location.origin,
    // })

    // Initialize MSAL
    await authService.initialize()
    // console.log('MSAL initialized successfully')

    // Check if running in Teams context
    const isInTeams = await teamsAuthService.isRunningInTeams()
    if (isInTeams) {
      // console.log('Running in Teams context')

      // Initialize Teams auth service
      const teamsConfig = {
        clientId: import.meta.env.VITE_AZURE_CLIENT_ID || '',
        tenantId: import.meta.env.VITE_AZURE_TENANT_ID || 'common',
        redirectUri: import.meta.env.VITE_REDIRECT_URI || window.location.origin,
      }

      // console.log('Teams configuration:', {
      //   hasClientId: !!teamsConfig.clientId,
      //   tenantId: teamsConfig.tenantId,
      //   redirectUri: teamsConfig.redirectUri,
      //   currentOrigin: window.location.origin,
      // })

      if (!teamsConfig.clientId) {
        console.error('VITE_AZURE_CLIENT_ID is not set! Teams authentication will fail.')
        console.error('Please check your .env file and ensure VITE_AZURE_CLIENT_ID is set.')
      }

      await teamsAuthService.initialize(teamsConfig)
      // console.log('Teams auth service initialized')

      // Check Teams configuration
      const configCheck = await teamsAuthService.checkTeamsConfiguration()
      if (!configCheck.isValid) {
        console.error('Teams configuration issues:', configCheck.errors)
      } else {
        // console.log('Teams configuration is valid')
      }
    } else {
      // console.log('Not running in Teams context')
    }
  } catch (error) {
    console.error('Auth initialization failed:', error)
  }
}

// Initialize auth before mounting the app
initializeAuth().then(async () => {
  // Handle redirect response if user is coming back from authentication
  try {
    const account = await authService.handleRedirectResponse()
    if (account) {
      // console.log('User authenticated via redirect:', account)
      // Store the authentication state
      localStorage.setItem('msal_token', 'authenticated')
      localStorage.setItem('msal_user', JSON.stringify(account))
    }
  } catch (error) {
    // console.log('No redirect response to handle:', error)
  }

  app.use(createPinia())
  app.use(router)
  app.use(vuetify)
  app.mount('#app')
})
